export default __webpack_public_path__ + "images/d57b998da3f84806c719ea414109b28d-mastercard-icon.svg";